<template>
  <div class="dictionary-bd bd">
    <div class="aside">
      <div class="title">
        <i class="icon icon-langset"></i>
        <span>{{ $t('base_dictionary.shu_ju_zi_dian') }}</span>
      </div>
      <div class="search">
        <el-select v-model="appId" style="width: 100%; margin-bottom: 16px;vertical-align: top;" :placeholder="$t('Common.com_please_select')" @change="getAppTree()">
          <el-option v-for="item in appList" :key="item.appId" :label="item.appName" :value="item.appId"></el-option>
        </el-select>
        <div class="ub">
          <div class="ub-f1">
            <el-input clearable :placeholder="$t('base_dictionary.fzmcfzdm')" style="width:100%" v-model="appKey"></el-input>
          </div>
          <div style="margin-left:10px">
            <add-button v-if="funcView.dictionary_group_add" @click="addDictionaryGroup()"></add-button>
          </div>
        </div>
      </div>
      <div class="tree">
        <custom-tree
          default
          :data="appTree"
          node-key="id"
          :listener="appKey"
          :filterKeys="['name', 'code']"
          :props="{ label: 'name' }"
          v-model="groupData"
          :action="treeAction"
          @add="addDictionaryGroup"
          @edit="editDictionaryGroup"
          @delete="deleteDictionaryGroup"
          @handleNode="handleNodeClick"
        ></custom-tree>
      </div>
    </div>
    <div class="section">
      <div class="section-info">
        <table>
          <tr>
            <th style="width: 220px">{{ $t('base_dictionary.fen_zu_ming_cheng') }}</th>
            <th style="width: 260px">{{ $t('base_dictionary.fen_zu_dai_ma') }}</th>
            <th style="width: 120px">{{ $t('base_dictionary.zi_dian_jie_gou') }}</th>
            <th style="width: 120px">{{ $t('base_dictionary.fen_zu_ji_bie') }}</th>
            <th>{{ $t('base_dictionary.fen_zu_miao_shu') }}</th>
          </tr>
          <tr>
            <td>{{ groupData.data ? groupData.data.groupName : '' }}</td>
            <td>{{ groupData.data ? groupData.data.groupCode : '' }}</td>
            <td>{{ groupData.data ? groupData.data.dicType : '' | formatDictionary(propertyMap.bas_dic_group_type) }}</td>
            <td>{{ groupData.data ? groupData.data.groupLevel : '' | formatDictionary(propertyMap.bas_dic_level) }}</td>
            <td>{{ groupData.data ? groupData.data.groupDesc : '' }}</td>
          </tr>
        </table>
      </div>
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-button type="primary" icon="el-icon-plus" @click="addGroupItem()" :disabled="!groupData.data" v-if="funcView.dictionary_add">{{ $t('Common.com_add') }}</el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <!-- 搜索栏 -->
          <el-form-item style="float: right" v-if="funcView.dictionary_select">
            <search-input v-model="formSearch.search" :placeholder="$t('base_dictionary.qsrzdmczddm')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table v-if="funcView.dictionary_list" row-key="dicId" tableCode="dic_manage" v-loading="isLoading" :data="groupItemList" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%">
          <el-table-column :label="$t('Common.com_handle')" fixed="right">
            <template slot-scope="scope">
              <el-button @click="editGroupItem(scope.row)" type="text" size="mini" v-if="funcView.dictionary_update">{{ $t('Common.com_edit') }}</el-button>
              <el-button @click="deleteGroupItem(scope.row)" type="text" size="mini" v-if="funcView.dictionary_delete">{{ $t('Common.com_delete') }}</el-button>
            </template>
          </el-table-column>
        </custom-table>
      </div>
      <div class="table-page" v-if="groupData.data && groupData.data.dicType == 1 && funcView.dictionary_list">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <dictionary-group-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="changeDictionaryGroup"></dictionary-group-dialog>
    <dictionary-item-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="getGroupItemData"></dictionary-item-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import addButton from '@/components/addButton';
import customTree from '@/components/customTree.vue';
import dictionaryGroupDialog from './children/dictionary_group_dialog.vue';
import dictionaryItemDialog from './children/dictionary_item_dialog.vue';

export default {
  name: 'dictionary',
  components: { dictionaryGroupDialog, dictionaryItemDialog, addButton, customTree },
  data() {
    return {
      appId: '',
      appList: [],
      appTree: [],
      groupData: {},
      appKey: '',

      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},

      formSearch: {
        search: '',
        groupCode: '',
        pageSize: 50,
        pageNum: 1
      },
      groupItemList: [],
      totalRows: null,
      isLoading: false
    };
  },
  computed: {
    treeAction() {
      return {
        add: this.funcView.dictionary_group_add,
        edit: this.funcView.dictionary_group_update,
        delete: this.funcView.dictionary_group_delete
      };
    }
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getAppList();
    this.getDictionary('bas_dic_group_type,bas_dic_level');
    this.getFuncView();
  },
  methods: {
    // 应用平台
    getAppList: function () {
      this.$getJSON(apis.AppMenu).then((res) => {
        this.appList = res.data;
        this.appId = res.data[0] && res.data[0]['appId'];
        this.getAppTree();
      });
    },
    // 获取平台字典树
    getAppTree: function () {
      this.groupData = {};
      this.$getJSON(apis.DictGroupTree, { appId: this.appId }).then((res) => {
        this.appTree = res.data || [];
      });
    },
    // 选中树字典项
    handleNodeClick: function () {
      if (this.resetFormSearch) {
        this.formSearch = JSON.parse(this.resetFormSearch);
        this.getGroupItemData();
      }
    },
    // 新增字典组
    addDictionaryGroup: function (data) {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('base_dictionary.xin_zeng_fen_zu');
      this.dialogModel.data = {
        groupLevels: this.propertyMap.bas_dic_level,
        groupTypes: this.propertyMap.bas_dic_group_type,
        appList: this.appList,
        appId: this.appId,
        appTree: this.appTree,
        group: data ? data.data : { groupId: null }
      };
      this.dialogVisible = true;
    },
    // 编辑字典组
    editDictionaryGroup: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('base_dictionary.bian_ji_fen_zu');
      this.dialogModel.data = {
        groupLevels: this.propertyMap.bas_dic_level,
        groupTypes: this.propertyMap.bas_dic_group_type,
        appList: this.appList,
        appId: this.appId,
        appTree: this.appTree,
        group: data.data
      };
      this.dialogVisible = true;
    },
    // 删除字典组
    deleteDictionaryGroup: function (data) {
      const tips = this.$t('base_dictionary.nqdyscdqfzm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.DictGroupDelete}/${data.id}`).then(() => {
            this.expandedKeys = [data.parentId];
            this.getAppTree();
          });
        })
        .catch(() => {});
    },
    // 字典组操作成功
    changeDictionaryGroup: function (form) {
      if (form) {
        this.$setFormatData(this.groupData.data, form, 'dicType,groupCode,groupDesc,groupLevel,groupName,langGroupName,parentId');
      }
      this.getAppTree();
      this.getGroupItemData();
    },
    getGroupItemData: function () {
      if (this.groupData.data && this.groupData.data.groupId) {
        this.isLoading = true;
        if (`${this.groupData.data.dicType}` === '1') {
          this.getGroupItemPage();
        } else {
          this.getGroupItemTree();
        }
      }
    },
    // 获取字典项列表
    getGroupItemPage: function () {
      this.formSearch.groupCode = this.groupData.data.groupCode;
      this.$getJSON(apis.DictionaryPage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.groupItemList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    getGroupItemTree: function () {
      this.$getJSON(apis.DictionaryTree, {
        search: this.formSearch.search,
        groupCode: this.groupData.data.groupCode
      }).then((res) => {
        this.isLoading = false;
        this.groupItemList = res.data;
        this.totalRows = null;
      });
    },
    // 新增字典项
    addGroupItem: function () {
      this.dialogModel1.type = 'add';
      this.dialogModel1.title = this.$t('base_dictionary.xin_zeng_zi_dian');
      this.dialogModel1.data = { group: this.groupData.data, groupItemList: this.groupItemList };
      this.dialogVisible1 = true;
    },
    // 编辑字典项
    editGroupItem: function (row) {
      this.dialogModel1.type = 'edit';
      this.dialogModel1.title = this.$t('base_dictionary.bian_ji_zi_dian');
      this.dialogModel1.data = { item: row, group: this.groupData.data, groupItemList: this.groupItemList };
      this.dialogVisible1 = true;
    },
    // 删除字典项
    deleteGroupItem: function (row) {
      this.$showConfirm(this.$t('base_dictionary.nqdyscgzdm'))
        .then(() => {
          this.$postJSON(`${apis.DictionaryDelete}/${row.dicId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success'
            });
            this.getGroupItemData();
          });
        })
        .catch(() => {});
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getGroupItemData();
    }
  }
};
</script>

<style lang="scss">
@import '@/style/mixin.scss';

.dictionary-bd {
  .section {
    .title {
      color: $title-color;
      font-size: 15px;
      line-height: 24px;
      padding-top: 20px;
      font-weight: bold;
      i {
        margin-right: 10px;
        color: #262626;
        font-size: 19px;
        float: left;
        line-height: 24px;
        font-weight: normal;
      }
    }
    .info-bd {
      padding: 10px 0 20px;
      border-bottom: 1px solid #eef2f8;
      .label {
        color: $font-color;
        font-size: 12px;
        line-height: 17px;
      }
      .value {
        color: $font-color;
        font-size: 12px;
        line-height: 17px;
      }
    }
  }
}
</style>
